
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4435_8486)"}},[_c('path',{attrs:{"d":"M4.998 20.5a.789.789 0 01-.408-.108.827.827 0 01-.425-.725v-2.832C1.549 15.144 0 12.437 0 9.513 0 4.548 4.481.5 9.996.5c5.514 0 9.996 4.04 9.996 9.013s-4.482 9.013-9.996 9.013c-.458 0-.916-.034-1.375-.084l-3.19 1.933a.816.816 0 01-.433.125zM9.996 2.174c-4.59 0-8.33 3.299-8.33 7.347 0 2.474 1.4 4.765 3.748 6.131.259.15.417.425.417.716v1.816l2.174-1.324a.82.82 0 01.558-.108c.475.075.958.108 1.433.108 4.59 0 8.33-3.299 8.33-7.347s-3.74-7.347-8.33-7.347v.008z"}}),_c('path',{attrs:{"d":"M9.996 12.17a.835.835 0 01-.833-.833v-.774c0-.734.533-1.367 1.333-1.575.45-.116.816-.383 1.016-.733a1.15 1.15 0 00.1-.908c-.133-.45-.583-.833-1.133-.95-.591-.133-1.216-.008-1.65.334-.324.258-.499.6-.499.966a.835.835 0 01-.833.833.835.835 0 01-.833-.833c0-.866.408-1.69 1.125-2.266.833-.666 1.949-.908 3.057-.658 1.133.258 2.057 1.083 2.365 2.108a2.78 2.78 0 01-.25 2.199c-.416.741-1.166 1.3-2.049 1.524a.429.429 0 00-.083.034v.707a.835.835 0 01-.833.833v-.008zM9.997 14.67a.833.833 0 100-1.667.833.833 0 000 1.666z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4435_8486"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    